import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { GoogleComponent } from '@pages/utils/google.component';
import { GoogleTagManagerEventEnum } from 'src/app/enums/GoogleTagManagerEvent.enum';
import { UploadFileService } from '@services/upload-file.service';
import { take } from 'rxjs/operators';
import { TagManagerDirective } from '../../directives/tag-manager.directive';

@Component({
    selector: 'app-alert-erro',
    templateUrl: './alert-erro.component.html',
    styleUrls: ['./alert-erro.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, TagManagerDirective]
})
export class AlertErroComponent extends GoogleComponent implements OnInit, OnChanges {

  @Input() alertErro: boolean = false;
  @Input() botao2: boolean = false;
  @Input() mensagemErro: string = 'Não foi possível enviar seu pedido! Por favor tente mais tarde.';
  @Input() sourceScreen: string = '';
  @Input() tituloMensagemErro: string = 'Ocorreu um erro!';
  @Output() alertErroFechou = new EventEmitter();

  public idEmpresaLogada: any = localStorage.idEmpresaLogada;
  public idImportacao: any;
  public showErros: any;

  constructor(
    private readonly service: UploadFileService,
    private readonly router: Router,
  ) {
    super();
  }

  ngOnInit(): void {
    this.idImportacao = localStorage.getItem('idImportacao');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.alertErro?.currentValue && this.sourceScreen !== '') {
      const model = this.buildTagFromSourceScreen(GoogleTagManagerEventEnum.screenView, null, null, this.sourceScreen);
      this.tagManagerService.pushTag(model);
    }
  }

  fecharAlertErro(type: any = false) {
    this.alertErro = false;
    this.alertErroFechou.emit(type);
  }

  cancelarImportacao() {
    this.fecharAlertErro();
    this.service.finalizaImportacao(this.idImportacao, 'cancelar').pipe(take(1)).subscribe(() => {
      localStorage.removeItem(localStorage.getItem('idEmpresaLogada') + '.ImportadorDadosComponent.avisoInconsistencia.value');
      this.router.navigate(['importador-dados']);
    });
  }

  public goToError() {
    localStorage.setItem(localStorage.getItem('idEmpresaLogada') + '.sawImportationError', 'true');
    this.router.navigate(['/visualizar-erros-importacao']);
  }

  addTagManagerInteraction(elementType: string, elementContent: string) {
    return this.buildTagFromSourceScreen(GoogleTagManagerEventEnum.interaction, elementType, elementContent, this.sourceScreen);
  }
}
